/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ion-list[_ngcontent-%COMP%]{width:100%}.defect-row[_ngcontent-%COMP%]{display:-webkit-box;display:flex}"];
export { styles as styles };
